<template>
  <span v-resize="checkMobile">
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <v-container fluid fill-height>
      <v-toolbar v-if="!isMobile" text :color="$vuetify.theme.dark ? '' : 'white'"
        class="align-center start-tour-analitic-1">
        <v-toolbar-title>
          {{ $t("analitics.common_company") }} {{ $t("custom.number") }}{{ report.id }} {{ start_date_formatted }} -
          {{ end_date_formatted }} ({{ getBranchName() }})</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-checkbox v-model="report.with_property" :label="$t('analitics.with_property_short')"
          @click="with_property_warn()" readonly class="mt-5 mr-2"></v-checkbox>
        <v-btn
          color="primary"
          class="mr-2"
          icon
          @click="recalculateReport"
          :title="$t('analitics.recalculate')"
          :loading="isRecalculating"
          :disabled="isRecalculating || isGenerating"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn icon @click="generateReport()">
          <v-icon color="success">mdi-download-circle-outline</v-icon>
        </v-btn>
        <v-btn icon :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
          }/${$root.$i18n.locale}/categories/8/guides/25`" target="_blank">
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>
      </v-toolbar>
      <v-toolbar v-else text :color="$vuetify.theme.dark ? '' : 'white'" class="align-center start-tour-analitic-1 mb-2"
        height="130px">
        <v-flex md12>
          <v-flex md12>
            <v-toolbar-title class="subtitle-1 text-center">{{ $t("analitics.common_company") }} {{ $t("custom.number")
              }}{{ report.id }}<br />{{ start_date_formatted }} -
              {{ end_date_formatted }}<br />({{ getBranchName() }})</v-toolbar-title>
          </v-flex>
          <v-flex md12 class="d-flex align-center justify-center">
            <v-checkbox v-model="report.with_property" :label="$t('analitics.with_property_short')"
              @click="with_property_warn()" readonly hide-details class="text-center"></v-checkbox>
          </v-flex>
          <v-flex md12 class="text-center">
            <v-btn
              color="primary"
              icon
              @click="recalculateReport"
              :loading="isRecalculating"
              :disabled="isRecalculating || isGenerating"
            >
              <v-icon left>mdi-refresh</v-icon>
            </v-btn>
            <v-btn icon @click="generateReport()">
              <v-icon color="success">mdi-download-circle-outline</v-icon>
            </v-btn>
            <v-btn icon :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
              }/${$root.$i18n.locale}/categories/8/guides/25`" target="_blank">
              <v-icon>mdi-help-circle</v-icon>
            </v-btn>
          </v-flex>
        </v-flex>
      </v-toolbar>

      <!-- Индикатор генерации отчета -->
      <v-flex v-if="isGenerating && !generationError" md12 class="mb-4 mt-4">
        <v-alert
          type="info"
          border="left"
          colored-border
          class="mb-4"
        >
          <v-row align="center">
            <v-col class="grow">
              <div class="text-h6">{{ $t('analitics.report_generating') }}</div>
              <div class="text-caption">
                {{ $t('analitics.report_ready') }}
                <span v-if="connected" class="success--text">● {{ $t('analitics.connected') }}</span>
                <span v-else class="error--text">● {{ $t('analitics.disconnected') }}</span>
              </div>
            </v-col>
          </v-row>
          <v-progress-linear
            :value="reportProgress"
            color="primary"
            height="20"
            class="mt-3"
            striped
          >
            <template v-slot:default>
              <strong>{{ reportProgress.toFixed(0) }}%</strong>
            </template>
          </v-progress-linear>
        </v-alert>
      </v-flex>
      
      <!-- Ошибка генерации отчета -->
      <v-flex v-if="generationError" md12 class="mb-4 mt-4">
        <v-alert
          type="error"
          border="left"
          colored-border
          class="mb-4"
        >
          <v-row align="center">
            <v-col class="grow">
              <div class="text-h6">{{ $t('analitics.report_generation_error') }}</div>
              <div class="text-body-2 mt-2">{{ generationError }}</div>
            </v-col>
          </v-row>
          <v-btn color="error" outlined class="mt-3" @click="retryGeneration">
            <v-icon left>mdi-refresh</v-icon>
            {{ $t('analitics.try_again') }}
          </v-btn>
        </v-alert>
      </v-flex>

      <!-- Расширенная аналитика - KPI карточки -->
      <v-flex v-if="report.state == 'created'" md12 class="mb-4 mt-4">
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-card color="success" dark class="pa-3 d-flex align-center justify-space-between" v-bind="attrs" v-on="on" style="cursor: help;">
                  <div>
                    <v-icon left size="40">mdi-percent-outline</v-icon>
                  </div>
                  <div class="text-right">
                    <div class="caption">{{ $t('analitics.margin_percent') }}</div>
                    <div class="text-h6 font-weight-bold">{{ marginPercent }}%</div>
                  </div>
                </v-card>
              </template>
              <span>{{ $t('analitics.formula') }}: {{ $t('analitics.margin_formula') }}<br/>
                ({{ parseFloat(report.income).toFixed(1) }} - {{ parseFloat(report.expense).toFixed(1) }}) / {{ parseFloat(report.income).toFixed(1) }} × 100</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-card color="primary" dark class="pa-3 d-flex align-center justify-space-between" v-bind="attrs" v-on="on" style="cursor: help;">
                  <div>
                    <v-icon left size="40">mdi-cash-plus</v-icon>
                  </div>
                  <div class="text-right">
                    <div class="caption">{{ $t('analitics.average_income_per_day') }}</div>
                    <div class="text-h6 font-weight-bold">{{ averageIncomePerDay }}{{ findCurrencySymbol(report.currency_id) }}</div>
                  </div>
                </v-card>
              </template>
              <span>{{ $t('analitics.formula') }}: {{ $t('analitics.average_income_formula') }}<br/>
                {{ parseFloat(report.income).toFixed(1) }} / {{ daysPeriod }} {{ $t('analitics.days_count') }}</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-card color="error" dark class="pa-3 d-flex align-center justify-space-between" v-bind="attrs" v-on="on" style="cursor: help;">
                  <div>
                    <v-icon left size="40">mdi-cash-minus</v-icon>
                  </div>
                  <div class="text-right">
                    <div class="caption">{{ $t('analitics.average_expense_per_day') }}</div>
                    <div class="text-h6 font-weight-bold">{{ averageExpensePerDay }}{{ findCurrencySymbol(report.currency_id) }}</div>
                  </div>
                </v-card>
              </template>
              <span>{{ $t('analitics.formula') }}: {{ $t('analitics.average_expense_formula') }}<br/>
                {{ parseFloat(report.expense).toFixed(1) }} / {{ daysPeriod }} {{ $t('analitics.days_count') }}</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-tooltip bottom max-width="400">
              <template v-slot:activator="{ on, attrs }">
                <v-card color="info" dark class="pa-3 d-flex align-center justify-space-between" v-bind="attrs" v-on="on" style="cursor: help;">
                  <div>
                    <v-icon left size="40">mdi-chart-line</v-icon>
                  </div>
                  <div class="text-right">
                    <div class="caption">{{ $t('analitics.ads_roi_short') }}</div>
                    <div class="text-h6 font-weight-bold">{{ adsRoiPercent }}%</div>
                  </div>
                </v-card>
              </template>
              <div style="line-height: 1.5;">
                <strong>{{ $t('analitics.formula') }}:</strong> {{ $t('analitics.ads_roi_formula') }}<br/>
                <strong>{{ $t('analitics.calculation') }}:</strong> ({{ parseFloat(report.income - report.expense).toFixed(1) }} / {{ parseFloat(report.ads_expense).toFixed(1) }}) × 100<br/>
                <br/>
                <strong>{{ $t('analitics.what_shows') }}:</strong><br/>
                {{ $t('analitics.ads_roi_explanation') }}<br/>
                <br/>
                <em>{{ $t('analitics.positive_value') }}:</em> {{ $t('analitics.ads_roi_positive') }}<br/>
                <em>{{ $t('analitics.negative_value') }}:</em> {{ $t('analitics.ads_roi_negative') }}<br/>
                <br/>
                <small><strong>{{ $t('analitics.note') }}:</strong> {{ $t('analitics.ads_roi_note') }}</small>
              </div>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-flex>

      <!-- Графики аналитики -->
      <v-flex v-if="report.state == 'created'" md12 class="mb-4">
        <v-row>
          <v-col cols="12" md="6" v-if="topIncomeData && topIncomeData.length > 1">
            <GChart
              style="width: 100%; height: 400px"
              type="BarChart"
              :options="topIncomeOptions"
              :settings="{
                packages: ['corechart'],
                language: this.$i18n.locale,
              }"
              :data="topIncomeData"
            />
          </v-col>
          <v-col cols="12" md="6" v-if="topExpenseData && topExpenseData.length > 1">
            <GChart
              style="width: 100%; height: 400px"
              type="BarChart"
              :options="topExpenseOptions"
              :settings="{
                packages: ['corechart'],
                language: this.$i18n.locale,
              }"
              :data="topExpenseData"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" v-if="operationalEfficiencyData && operationalEfficiencyData.length > 1">
            <GChart
              style="width: 100%; height: 400px"
              type="ColumnChart"
              :options="operationalEfficiencyOptions"
              :settings="{
                packages: ['corechart'],
                language: this.$i18n.locale,
              }"
              :data="operationalEfficiencyData"
            />
          </v-col>
        </v-row>
      </v-flex>

      <!-- По компании -->
      <v-flex v-if="report.state == 'created'" md12 :class="isMobile ? '' : 'd-flex align-stretch'">
        <v-flex md6 sm12 class="d-flex flex-column">
          <v-simple-table :dense="isMobile ? true : false" class="flex-grow-1">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">
                    {{ $t("analitics.income") }}
                  </th>
                  <th class="text-center">
                    {{ $t("custom.sum") }}
                  </th>
                  <th class="text-center">
                    {{ $t("analitics.part_income") }}
                  </th>
                  <th class="text-center">
                    {{ $t("analitics.expence") }}
                  </th>
                  <th class="text-center">
                    {{ $t("custom.sum") }}
                  </th>
                  <th class="text-center">
                    {{ $t("analitics.part_expences") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('rent_income', $t('counts.rental_cost'))">
                    {{ $t("counts.rental_cost") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('rent_income', $t('counts.rental_cost'))">
                    {{ parseFloat(report.rent_income).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('rent_income', $t('counts.rental_cost'))">
                    {{
                      parseFloat(
                        (report.rent_income /
                          (report.income == 0 ? 1 : report.income)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                  <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('salary_expense', $t('counts.salary'))">
                    {{ $t("counts.salary") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('salary_expense', $t('counts.salary'))">
                    {{ parseFloat(report.salary_expense).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('salary_expense', $t('counts.salary'))">
                    {{
                      parseFloat(
                        (report.salary_expense /
                          (report.expense == 0 ? 1 : report.expense)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                </tr>
                <tr>
                  <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('delivery_income', $t('counts.delivery'))">
                    {{ $t("counts.delivery") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('delivery_income', $t('counts.delivery'))">
                    {{ parseFloat(report.delivery_income).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('delivery_income', $t('counts.delivery'))">
                    {{
                      parseFloat(
                        (report.delivery_income /
                          (report.income == 0 ? 1 : report.income)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                  <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('transport_expense', $t('counts.transport_expences'))">
                    {{ $t("counts.transport_expences") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('transport_expense', $t('counts.transport_expences'))">
                    {{ parseFloat(report.transport_expense).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('transport_expense', $t('counts.transport_expences'))">
                    {{
                      parseFloat(
                        (report.transport_expense /
                          (report.expense == 0 ? 1 : report.expense)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                </tr>
                <tr>
                  <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('checkout_income', $t('counts.checkout'))">
                    {{ $t("counts.checkout") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('checkout_income', $t('counts.checkout'))">
                    {{ parseFloat(report.checkout_income).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('checkout_income', $t('counts.checkout'))">
                    {{
                      parseFloat(
                        (report.checkout_income /
                          (report.income == 0 ? 1 : report.income)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                  <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('common_expense', $t('counts.common_expences'))">
                    {{ $t("counts.common_expences") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('common_expense', $t('counts.common_expences'))">
                    {{ parseFloat(report.common_expense).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('common_expense', $t('counts.common_expences'))">
                    {{
                      parseFloat(
                        (report.common_expense /
                          (report.expense == 0 ? 1 : report.expense)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                </tr>
                <tr>
                  <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('fuel_income', $t('counts.gas_payments'))">
                    {{ $t("counts.gas_payments") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('fuel_income', $t('counts.gas_payments'))">
                    {{ parseFloat(report.fuel_income).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('fuel_income', $t('counts.gas_payments'))">
                    {{
                      parseFloat(
                        (report.fuel_income /
                          (report.income == 0 ? 1 : report.income)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                  <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('fuel_expense', $t('counts.gas_fill'))">
                    {{ $t("counts.gas_fill") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('fuel_expense', $t('counts.gas_fill'))">
                    {{ parseFloat(report.fuel_expense).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('fuel_expense', $t('counts.gas_fill'))">
                    {{
                      parseFloat(
                        (report.fuel_expense /
                          (report.expense == 0 ? 1 : report.expense)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                </tr>
                <tr>
                  <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('clean_income', $t('counts.clean_payments'))">
                    {{ $t("counts.clean_payments") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('clean_income', $t('counts.clean_payments'))">
                    {{ parseFloat(report.clean_income).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('clean_income', $t('counts.clean_payments'))">
                    {{
                      parseFloat(
                        (report.clean_income /
                          (report.income == 0 ? 1 : report.income)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                  <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('clean_expense', $t('custom.clean'))">
                    {{ $t("custom.clean") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('clean_expense', $t('custom.clean'))">
                    {{ parseFloat(report.clean_expense).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('clean_expense', $t('custom.clean'))">
                    {{
                      parseFloat(
                        (report.clean_expense /
                          (report.expense == 0 ? 1 : report.expense)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                </tr>
                <tr>
                  <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('add_time_income', $t('counts.add_hours_payments'))">
                    {{ $t("counts.add_hours_payments") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('add_time_income', $t('counts.add_hours_payments'))">
                    {{ parseFloat(report.add_time_income).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('add_time_income', $t('counts.add_hours_payments'))">
                    {{
                      parseFloat(
                        (report.add_time_income /
                          (report.income == 0 ? 1 : report.income)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                  <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('repair_expense', $t('counts.repair'))">
                    {{ $t("counts.repair") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('repair_expense', $t('counts.repair'))">
                    {{ parseFloat(report.repair_expense).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('repair_expense', $t('counts.repair'))">
                    {{
                      parseFloat(
                        (report.repair_expense /
                          (report.expense == 0 ? 1 : report.expense)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                </tr>
                <tr>
                  <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('damages_income', $t('counts.repair_payments'))">
                    {{ $t("counts.repair_payments") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('damages_income', $t('counts.repair_payments'))">
                    {{ parseFloat(report.damages_income).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('damages_income', $t('counts.repair_payments'))">
                    {{
                      parseFloat(
                        (report.damages_income /
                          (report.income == 0 ? 1 : report.income)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                  <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('service_expense', $t('custom.service'))">
                    {{ $t("custom.service") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('service_expense', $t('custom.service'))">
                    {{ parseFloat(report.service_expense).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('service_expense', $t('custom.service'))">
                    {{
                      parseFloat(
                        (report.service_expense /
                          (report.expense == 0 ? 1 : report.expense)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                </tr>
                <tr>
                  <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('fines_income', $t('counts.fines_payments'))">
                    {{ $t("counts.fines_payments") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('fines_income', $t('counts.fines_payments'))">
                    {{ parseFloat(report.fines_income).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('fines_income', $t('counts.fines_payments'))">
                    {{
                      parseFloat(
                        (report.fines_income /
                          (report.income == 0 ? 1 : report.income)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                  <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('fines_expense', $t('custom.fines'))">
                    {{ $t("custom.fines") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('fines_expense', $t('custom.fines'))">
                    {{ parseFloat(report.fines_expense).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('fines_expense', $t('custom.fines'))">
                    {{
                      parseFloat(
                        (report.fines_expense /
                          (report.expense == 0 ? 1 : report.expense)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                </tr>
                <tr>
                  <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('other_income', $t('counts.other_payments'))">
                    {{ $t("counts.other_payments") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('other_income', $t('counts.other_payments'))">
                    {{ parseFloat(report.other_income).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('other_income', $t('counts.other_payments'))">
                    {{
                      parseFloat(
                        (report.other_income /
                          (report.income == 0 ? 1 : report.income)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                  <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('taxes_expense', $t('counts.taxes'))">
                    {{ $t("counts.taxes") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('taxes_expense', $t('counts.taxes'))">
                    {{ parseFloat(report.taxes_expense).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('taxes_expense', $t('counts.taxes'))">
                    {{
                      parseFloat(
                        (report.taxes_expense /
                          (report.expense == 0 ? 1 : report.expense)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                </tr>
                <tr>
                  <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('mileage_income', $t('groups_counts.mileage'))">
                    {{ $t("groups_counts.mileage") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('mileage_income', $t('groups_counts.mileage'))">
                    {{ parseFloat(report.mileage_income).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('mileage_income', $t('groups_counts.mileage'))">
                    {{
                      parseFloat(
                        (report.mileage_income /
                          (report.income == 0 ? 1 : report.income)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                  <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('ads_expense', $t('counts.ads'))">
                    {{ $t("counts.ads") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('ads_expense', $t('counts.ads'))">
                    {{ parseFloat(report.ads_expense).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('ads_expense', $t('counts.ads'))">
                    {{
                      parseFloat(
                        (report.ads_expense /
                          (report.expense == 0 ? 1 : report.expense)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                </tr>
                <tr v-if="report.with_property">
                  <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('sale_property_income', $t('counts.sell_property'))">
                    {{ $t("counts.sell_property") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('sale_property_income', $t('counts.sell_property'))">
                    {{ parseFloat(report.sale_property_income).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('sale_property_income', $t('counts.sell_property'))">
                    {{
                      parseFloat(
                        (report.sale_property_income /
                          (report.income == 0 ? 1 : report.income)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                  <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('buy_property_expense', $t('counts.buy_property'))">
                    {{ $t("counts.buy_property") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('buy_property_expense', $t('counts.buy_property'))">
                    {{ parseFloat(report.buy_property_expense).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('buy_property_expense', $t('counts.buy_property'))">
                    {{
                      parseFloat(
                        (report.buy_property_expense /
                          (report.expense == 0 ? 1 : report.expense)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                </tr>
                <tr>
                  <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('insurance_income', $t('counts.insurance_payments'))">
                    {{ $t("counts.insurance_payments") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('insurance_income', $t('counts.insurance_payments'))">
                    {{ parseFloat(report.insurance_income).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('insurance_income', $t('counts.insurance_payments'))">
                    {{
                      parseFloat(
                        (report.insurance_income /
                          (report.income == 0 ? 1 : report.income)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                  <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('insurance_expense', $t('custom.insurance'))">
                    {{ $t("custom.insurance") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('insurance_expense', $t('custom.insurance'))">
                    {{ parseFloat(report.insurance_expense).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('insurance_expense', $t('custom.insurance'))">
                    {{
                      parseFloat(
                        (report.insurance_expense /
                          (report.expense == 0 ? 1 : report.expense)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                </tr>
                <tr>
                  <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('drivers_income', $t('counts.drivers_payments'))">
                    {{ $t("counts.drivers_payments") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('drivers_income', $t('counts.drivers_payments'))">
                    {{ parseFloat(report.drivers_income).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('drivers_income', $t('counts.drivers_payments'))">
                    {{
                      parseFloat(
                        (report.drivers_income /
                          (report.income == 0 ? 1 : report.income)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                  <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('rent_property_expense', $t('counts.rent_office'))">
                    {{ $t("counts.rent_office") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('rent_property_expense', $t('counts.rent_office'))">
                    {{ parseFloat(report.rent_property_expense).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('rent_property_expense', $t('counts.rent_office'))">
                    {{
                      parseFloat(
                        (report.rent_property_expense /
                          (report.expense == 0 ? 1 : report.expense)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                </tr>
                <tr>
                  <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('equipment_income', $t('groups_counts.equipment'))">
                    {{ $t("groups_counts.equipment") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('equipment_income', $t('groups_counts.equipment'))">
                    {{ parseFloat(report.equipment_income).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('equipment_income', $t('groups_counts.equipment'))">
                    {{
                      parseFloat(
                        (report.equipment_income /
                          (report.income == 0 ? 1 : report.income)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                  <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('partners_expense', $t('counts.partners_payments'))">
                    {{ $t("counts.partners_payments") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('partners_expense', $t('counts.partners_payments'))">
                    {{ parseFloat(report.partners_expense).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('partners_expense', $t('counts.partners_payments'))">
                    {{
                      parseFloat(
                        (report.partners_expense /
                          (report.expense == 0 ? 1 : report.expense)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                </tr>
                <tr>
                  <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('different_income', $t('groups_counts.different_income'))">
                    {{ $t("groups_counts.different_income") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('different_income', $t('groups_counts.different_income'))">
                    {{ parseFloat(report.different_income).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('different_income', $t('groups_counts.different_income'))">
                    {{
                      parseFloat(
                        (report.different_income /
                          (report.income == 0 ? 1 : report.income)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                  <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('other_expence', $t('groups_counts.other_expence'))">
                    {{ $t("groups_counts.other_expence") }}
                  </th>
                  <td style="text-align: center; cursor: pointer" @click="showCategoryDetails('other_expence', $t('groups_counts.other_expence'))">
                    {{ parseFloat(report.other_expence).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td style="text-align: center; cursor: pointer" @click="showCategoryDetails('other_expence', $t('groups_counts.other_expence'))">
                    {{
                      parseFloat(
                        (report.other_expence /
                          (report.expense == 0 ? 1 : report.expense)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                </tr>
                <tr>
                  <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                    "></th>
                  <td class="text-center"></td>
                  <td class="text-center"></td>
                  <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                    " style="cursor: pointer" @click="showCategoryDetails('parts_expense', $t('counts.parts'))">
                    {{ $t("counts.parts") }}
                  </th>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('parts_expense', $t('counts.parts'))">
                    {{ parseFloat(report.parts_expense).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center" style="cursor: pointer" @click="showCategoryDetails('parts_expense', $t('counts.parts'))">
                    {{
                      parseFloat(
                        (report.parts_expense /
                          (report.expense == 0 ? 1 : report.expense)) *
                        100
                      ).toFixed(1)
                    }}%
                  </td>
                </tr>
                <tr>
                  <th :class="$vuetify.theme.dark
                    ? 'green darken-3 title'
                    : 'green lighten-3 title'
                    ">
                    {{ $t("analitics.incomes") }}
                  </th>
                  <td class="text-center subtitle-1">
                    {{ parseFloat(report.income).toFixed(1) }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center"></td>
                  <th :class="$vuetify.theme.dark
                    ? 'red darken-4 title'
                    : 'red lighten-3 title'
                    ">
                    {{ $t("analitics.expences") }}
                  </th>
                  <td class="text-center subtitle-1">
                    {{ parseFloat(report.expense).toFixed(1) }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center"></td>
                </tr>
                <tr>
                  <th :class="$vuetify.theme.dark
                    ? 'green darken-2 title'
                    : 'green lighten-3 title'
                    " colspan="4">
                    {{ $t("analitics.profit") }}
                  </th>
                  <td class="text-center title">
                    {{ parseFloat(report.income - report.expense).toFixed(1)
                    }}{{ findCurrencySymbol(report.currency_id) }}
                  </td>
                  <td class="text-center"></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-flex>
        <v-flex md6 sm12 class="d-flex flex-column">
          <!-- Общий за период -->
          <v-flex md12 sm12 v-if="showRevenueGraf && revenue_for_period_data && revenue_for_period_data.length > 1" class="flex-grow-1">
            <GChart style="width: 100%; height: 100%; min-height: 200px" type="BarChart"
              :options="barChartOptions" :settings="{
                packages: ['corechart'],
                language: this.$i18n.locale,
              }" :data="revenue_for_period_data" />
          </v-flex>
          <v-flex md12 sm12 v-if="showRevenueGraf && pie_chart_income_data && pie_chart_income_data.length > 1" class="flex-grow-1">
            <GChart style="width: 100%; height: 100%; min-height: 200px" type="PieChart" :options="pieIncomeOptions" :settings="{
              packages: ['corechart'],
              language: this.$i18n.locale,
            }" :data="pie_chart_income_data" />
          </v-flex>
          <v-flex md12 sm12 v-if="showRevenueGraf && pie_chart_expences_data && pie_chart_expences_data.length > 1" class="flex-grow-1">
            <GChart style="width: 100%; height: 100%; min-height: 200px" type="PieChart" :options="pieExpencesOptions" :settings="{
              packages: ['corechart'],
              language: this.$i18n.locale,
            }" :data="pie_chart_expences_data" />
          </v-flex>
        </v-flex>
      </v-flex>

      <v-flex v-else md12 class="text-center mt-10">
        {{ $t("analitics.report_in_progress") }}
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        <br />
        <v-btn @click="$router.go()">{{ $t("custom.update") }}</v-btn>
      </v-flex>
    </v-container>
    <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="true" filename="report.pdf"
      :pdf-quality="2" pdf-format="a4" pdf-orientation="landscape" :margin="[20, 40]"
      :paginate-elements-by-height="1400" pdf-content-width="100%" @hasStartedGeneration="isLoading = true"
      @hasGenerated="isLoading = false" ref="html2Pdf">
      <section slot="pdf-content">
        <h2 style="text-align: center; margin-top: 20px">
          {{ $t("analitics.common_company") }} {{ $t("custom.number")
          }}{{ report.id }} {{ start_date_formatted }} -
          {{ end_date_formatted }}
        </h2>

        <v-simple-table dense class="mx-auto ml-3">
          <template v-slot:default>
            <thead>
              <tr style="text-align: left">
                <th style="text-align: center">
                  {{ $t("analitics.income") }}
                </th>
                <th style="text-align: center">
                  {{ $t("custom.sum") }}
                </th>
                <th style="text-align: center">
                  {{ $t("analitics.part_income") }}
                </th>
                <th style="text-align: center">
                  {{ $t("analitics.expence") }}
                </th>
                <th style="text-align: center">
                  {{ $t("custom.sum") }}
                </th>
                <th style="text-align: center">
                  {{ $t("analitics.part_expences") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                  ">
                  {{ $t("counts.rental_cost") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.rent_income).toFixed(1) }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.rent_income /
                        (report.income == 0 ? 1 : report.income)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
                <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                  ">
                  {{ $t("counts.salary") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.salary_expense).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.salary_expense /
                        (report.expense == 0 ? 1 : report.expense)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
              </tr>
              <tr>
                <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                  ">
                  {{ $t("counts.delivery") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.delivery_income).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.delivery_income /
                        (report.income == 0 ? 1 : report.income)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
                <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                  ">
                  {{ $t("counts.transport_expences") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.transport_expense).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.transport_expense /
                        (report.expense == 0 ? 1 : report.expense)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
              </tr>
              <tr>
                <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                  ">
                  {{ $t("counts.checkout") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.checkout_income).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.checkout_income /
                        (report.income == 0 ? 1 : report.income)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
                <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                  ">
                  {{ $t("counts.common_expences") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.common_expense).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.common_expense /
                        (report.expense == 0 ? 1 : report.expense)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
              </tr>
              <tr>
                <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                  ">
                  {{ $t("counts.gas_payments") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.fuel_income).toFixed(1) }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.fuel_income /
                        (report.income == 0 ? 1 : report.income)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
                <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                  ">
                  {{ $t("counts.gas_fill") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.fuel_expense).toFixed(1) }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.fuel_expense /
                        (report.expense == 0 ? 1 : report.expense)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
              </tr>
              <tr>
                <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                  ">
                  {{ $t("counts.clean_payments") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.clean_income).toFixed(1) }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.clean_income /
                        (report.income == 0 ? 1 : report.income)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
                <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                  ">
                  {{ $t("custom.clean") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.clean_expense).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.clean_expense /
                        (report.expense == 0 ? 1 : report.expense)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
              </tr>
              <tr>
                <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                  ">
                  {{ $t("counts.add_hours_payments") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.add_time_income).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.add_time_income /
                        (report.income == 0 ? 1 : report.income)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
                <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                  ">
                  {{ $t("counts.repair") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.repair_expense).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.repair_expense /
                        (report.expense == 0 ? 1 : report.expense)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
              </tr>
              <tr>
                <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                  ">
                  {{ $t("counts.repair_payments") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.damages_income).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.damages_income /
                        (report.income == 0 ? 1 : report.income)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
                <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                  ">
                  {{ $t("custom.service") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.service_expense).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.service_expense /
                        (report.expense == 0 ? 1 : report.expense)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
              </tr>
              <tr>
                <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                  ">
                  {{ $t("counts.fines_payments") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.fines_income).toFixed(1) }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.fines_income /
                        (report.income == 0 ? 1 : report.income)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
                <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                  ">
                  {{ $t("custom.fines") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.fines_expense).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.fines_expense /
                        (report.expense == 0 ? 1 : report.expense)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
              </tr>
              <tr>
                <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                  ">
                  {{ $t("counts.other_payments") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.other_income).toFixed(1) }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.other_income /
                        (report.income == 0 ? 1 : report.income)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
                <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                  ">
                  {{ $t("counts.taxes") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.taxes_expense).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.taxes_expense /
                        (report.expense == 0 ? 1 : report.expense)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
              </tr>
              <tr>
                <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                  ">
                  {{ $t("groups_counts.mileage") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.mileage_income).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.mileage_income /
                        (report.income == 0 ? 1 : report.income)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
                <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                  ">
                  {{ $t("counts.ads") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.ads_expense).toFixed(1) }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.ads_expense /
                        (report.expense == 0 ? 1 : report.expense)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
              </tr>
              <tr v-if="report.with_property">
                <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                  ">
                  {{ $t("counts.sell_property") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.sale_property_income).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.sale_property_income /
                        (report.income == 0 ? 1 : report.income)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
                <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                  ">
                  {{ $t("counts.buy_property") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.buy_property_expense).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.buy_property_expense /
                        (report.expense == 0 ? 1 : report.expense)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
              </tr>
              <tr>
                <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                  ">
                  {{ $t("counts.insurance_payments") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.insurance_income).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.insurance_income /
                        (report.income == 0 ? 1 : report.income)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
                <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                  ">
                  {{ $t("custom.insurance") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.insurance_expense).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.insurance_expense /
                        (report.expense == 0 ? 1 : report.expense)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
              </tr>
              <tr>
                <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                  ">
                  {{ $t("counts.drivers_payments") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.drivers_income).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.drivers_income /
                        (report.income == 0 ? 1 : report.income)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
                <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                  ">
                  {{ $t("counts.rent_office") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.rent_property_expense).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.rent_property_expense /
                        (report.expense == 0 ? 1 : report.expense)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
              </tr>
              <tr>
                <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                  ">
                  {{ $t("groups_counts.equipment") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.equipment_income).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.equipment_income /
                        (report.income == 0 ? 1 : report.income)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
                <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                  ">
                  {{ $t("counts.partners_payments") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.partners_expense).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.partners_expense /
                        (report.expense == 0 ? 1 : report.expense)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
              </tr>
              <tr>
                <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                  ">
                  {{ $t("groups_counts.different_income") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.different_income).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.different_income /
                        (report.income == 0 ? 1 : report.income)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
                <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                  ">
                  {{ $t("groups_counts.other_expence") }}
                </th>
                <td style="text-align: center">
                  {{ parseFloat(report.other_expence).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td style="text-align: center">
                  {{
                    parseFloat(
                      (report.other_expence /
                        (report.expense == 0 ? 1 : report.expense)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
              </tr>
              <tr>
                <th :class="$vuetify.theme.dark ? 'green darken-1' : 'green lighten-4'
                  "></th>
                <td class="text-center"></td>
                <td class="text-center"></td>
                <th :class="$vuetify.theme.dark ? 'red darken-1' : 'red lighten-4'
                  ">
                  {{ $t("counts.parts") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.parts_expense).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center">
                  {{
                    parseFloat(
                      (report.parts_expense /
                        (report.expense == 0 ? 1 : report.expense)) *
                      100
                    ).toFixed(1)
                  }}%
                </td>
              </tr>
              <tr>
                <th class="green lighten-3">
                  {{ $t("analitics.incomes") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.income).toFixed(1) }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center"></td>
                <th class="red lighten-3">
                  {{ $t("analitics.expences") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.expense).toFixed(1) }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center"></td>
              </tr>
              <tr>
                <th class="green lighten-1" colspan="4">
                  {{ $t("analitics.profit") }}
                </th>
                <td class="text-center">
                  {{ parseFloat(report.income - report.expense).toFixed(1)
                  }}{{ findCurrencySymbol(report.currency_id) }}
                </td>
                <td class="text-center"></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <div class="html2pdf__page-break" />
        <v-flex md12 sm12 v-if="showRevenueGraf">
          <GChart style="width: 1200px" type="BarChart" :options="barChartOptionsPdf"
            :settings="{ packages: ['corechart'], language: this.$i18n.locale }" :data="revenue_for_period_data" />
        </v-flex>
        <div class="html2pdf__page-break" />
        <v-flex md12 sm12 v-if="showRevenueGraf" class="justify-start">
          <GChart style="width: 900px" type="PieChart" :options="pieIncomeOptionsPdf"
            :settings="{ packages: ['corechart'], language: this.$i18n.locale }" :data="pie_chart_income_data" />
        </v-flex>
        <div class="html2pdf__page-break" />
        <v-flex md12 sm12 v-if="showRevenueGraf" class="justify-start">
          <GChart style="width: 900px" type="PieChart" :options="pieExpencesOptionsPdf"
            :settings="{ packages: ['corechart'], language: this.$i18n.locale }" :data="pie_chart_expences_data" />
        </v-flex>
        <div class="html2pdf__page-break" />
        
        <!-- KPI Метрики в PDF -->
        <h3 style="text-align: center; margin-top: 20px; margin-bottom: 20px">{{ $t('analitics.key_metrics') }}</h3>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 30px;">
          <tr>
            <td style="width: 25%; padding: 15px; text-align: center; background-color: #4CAF50; color: white;">
              <div style="font-size: 12px; margin-bottom: 5px;">{{ $t('analitics.margin_percent') }}</div>
              <div style="font-size: 24px; font-weight: bold;">{{ marginPercent }}%</div>
            </td>
            <td style="width: 25%; padding: 15px; text-align: center; background-color: #2196F3; color: white;">
              <div style="font-size: 12px; margin-bottom: 5px;">{{ $t('analitics.average_income_per_day') }}</div>
              <div style="font-size: 24px; font-weight: bold;">{{ averageIncomePerDay }}{{ findCurrencySymbol(report.currency_id) }}</div>
            </td>
            <td style="width: 25%; padding: 15px; text-align: center; background-color: #F44336; color: white;">
              <div style="font-size: 12px; margin-bottom: 5px;">{{ $t('analitics.average_expense_per_day') }}</div>
              <div style="font-size: 24px; font-weight: bold;">{{ averageExpensePerDay }}{{ findCurrencySymbol(report.currency_id) }}</div>
            </td>
            <td style="width: 25%; padding: 15px; text-align: center; background-color: #00BCD4; color: white;">
              <div style="font-size: 12px; margin-bottom: 5px;">{{ $t('analitics.ads_roi_short') }}</div>
              <div style="font-size: 24px; font-weight: bold;">{{ adsRoiPercent }}%</div>
            </td>
          </tr>
        </table>

        <div class="html2pdf__page-break" />
        <v-flex md12 sm12>
          <GChart style="width: 1200px; height: 600px" type="BarChart" :options="topIncomeOptionsPdf"
            :settings="{ packages: ['corechart'], language: this.$i18n.locale }" :data="topIncomeData" />
        </v-flex>
        <div class="html2pdf__page-break" />
        <v-flex md12 sm12>
          <GChart style="width: 1200px; height: 600px" type="BarChart" :options="topExpenseOptionsPdf"
            :settings="{ packages: ['corechart'], language: this.$i18n.locale }" :data="topExpenseData" />
        </v-flex>
        <div class="html2pdf__page-break" />
        <v-flex md12 sm12>
          <GChart style="width: 1200px; height: 600px" type="ColumnChart" :options="operationalEfficiencyOptionsPdf"
            :settings="{ packages: ['corechart'], language: this.$i18n.locale }" :data="operationalEfficiencyData" />
        </v-flex>
      </section>
    </vue-html2pdf>

    <!-- Диалог с детальными платежами по категории -->
    <v-dialog v-model="categoryDialog" :fullscreen="isMobile" max-width="1400px" scrollable>
      <v-card>
        <v-card-title class="headline">
          <span>{{ categoryTitle }}</span>
          <v-chip v-if="categoryPayments.length > 0" class="ml-3" :color="categoryType.includes('income') ? 'success' : 'error'" text-color="white">
            {{ categoryTotalSum.toFixed(2) }} {{ findCurrencySymbol(report.currency_id) }}
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn icon @click="categoryDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider></v-divider>
        
        <v-card-text style="max-height: 70vh" class="pa-0">
          <v-progress-linear v-if="loadingPayments" indeterminate color="primary"></v-progress-linear>
          
          <v-data-table
            v-if="!loadingPayments && categoryPayments.length > 0"
            :headers="company && company.multicurrency_cashboxes ? paymentHeadersWithCurrency : paymentHeaders"
            :items="categoryPayments"
            :items-per-page="20"
            :dense="isMobile"
            mobile-breakpoint="100"
            :sort-by="['created_at']"
            :sort-desc="[true]"
            :class="!isMobile ? '' : 'is-mobile'"
            :footer-props="tableFooterProps([20, 50, 100])"
          >
            <template slot="item" slot-scope="props">
              <tr :class="props.item.operation && props.item.sum < 0 ? 'red--text' : ''">
                <td class="text-center">{{ props.item.id }}</td>
                <td class="text-center" nowrap>{{ returnDate(props.item.created_at) }}</td>
                <td class="text-center">{{ translateCategory(props.item.group) }}</td>
                <td v-if="company && company.multicurrency_cashboxes" class="text-center">
                  {{ findCashboxName(props.item.company_cashbox_id, props.item.currency_id) }}
                </td>
                <td class="text-center">{{ props.item.description }}</td>
                <td v-if="company && company.multicurrency_cashboxes" class="text-center">
                  <span>{{ props.item.sum }}{{ findCurrencySymbol(props.item.currency_id) }}</span>
                  <span v-if="props.item.rate && (props.item.rate != 1 && props.item.rate != 0) && props.item.rate != null">
                    ({{ props.item.rated_sum }})
                  </span>
                </td>
                <td v-else class="text-center">
                  <span>{{ props.item.sum }}{{ findCurrencySymbol(props.item.currency_id) }}</span>
                </td>
                <td class="text-center" v-if="props.item.operation">
                  <v-icon class="text-center" style="color: green">mdi-plus-circle-outline</v-icon>
                </td>
                <td class="text-center" v-if="!props.item.operation">
                  <v-icon class="text-center" style="color: tomato">mdi-minus-circle-outline</v-icon>
                </td>
                <td class="text-center" v-if="props.item.cash">
                  <v-icon class="text-center" color="success">mdi-cash</v-icon>
                  <v-icon v-if="props.item.yandex_pay" class="text-center" color="error" :title="$t('yandex_pay.title')">
                    mdi-alpha-y-circle
                  </v-icon>
                  <v-icon v-if="props.item.stripe" class="text-center" color="primary" :title="$t('stripe_payment.title')">
                    mdi-alpha-s-circle-outline
                  </v-icon>
                </td>
                <td class="text-center" v-if="props.item.cashless">
                  <v-icon class="text-center" color="warning">mdi-contactless-payment-circle-outline</v-icon>
                  <v-icon v-if="props.item.yandex_pay" class="text-center" color="error" :title="$t('yandex_pay.title')">
                    mdi-alpha-y-circle
                  </v-icon>
                  <v-icon v-if="props.item.stripe" class="text-center" color="primary" :title="$t('stripe_payment.title')">
                    mdi-alpha-s-circle-outline
                  </v-icon>
                </td>
                <td class="text-center" v-if="props.item.entity">
                  <v-icon class="text-center" color="secondery">mdi-bank</v-icon>
                  <v-icon v-if="props.item.yandex_pay" class="text-center" color="error" :title="$t('yandex_pay.title')">
                    mdi-alpha-y-circle
                  </v-icon>
                  <v-icon v-if="props.item.stripe" class="text-center" color="primary" :title="$t('stripe_payment.title')">
                    mdi-alpha-s-circle-outline
                  </v-icon>
                </td>
                <td class="text-center" v-if="props.item.cash_card">
                  <v-icon class="text-center" color="info">mdi-credit-card-check-outline</v-icon>
                  <v-icon v-if="props.item.yandex_pay" class="text-center" color="error" :title="$t('yandex_pay.title')">
                    mdi-alpha-y-circle
                  </v-icon>
                  <v-icon v-if="props.item.stripe" class="text-center" color="primary" :title="$t('stripe_payment.title')">
                    mdi-alpha-s-circle-outline
                  </v-icon>
                </td>
                <td class="text-center">
                  <router-link v-if="props.item.contractor_id" :to="{ path: `/contractors/${props.item.contractor_id}` }">
                    {{ props.item.contractor_id }}
                  </router-link>
                  <span v-else>-</span>
                </td>
                <td class="text-left" nowrap v-if="props.item.booking_id && props.item.car_id && props.item.car_code">
                  <p>
                    {{ $t("bookings.booking") }}:
                    <router-link :to="{ path: `/bookings/${props.item.booking_id}` }">{{ props.item.booking_id }}</router-link>
                  </p>
                  <p>
                    {{ $t("custom.car") }}:
                    <router-link :to="{ path: `/cars/${props.item.car_id}` }">{{ props.item.car_code }}</router-link>
                  </p>
                </td>
                <td class="text-center" v-else-if="props.item.car_id && props.item.car_code">
                  <router-link :to="{ path: `/cars/${props.item.car_id}` }">{{ props.item.car_code }}</router-link>
                </td>
                <td class="text-center" v-else-if="props.item.yandex_pay || props.item.stripe">
                  <router-link v-if="props.item.client_id" :to="{ path: `/clients/${props.item.client_id}` }">
                    {{ $t("bookings.client") }}
                  </router-link>
                </td>
                <td class="text-center" v-else-if="props.item.debt_id">
                  {{ $t("debts.debt") }} {{ $t("custom.number") }}{{ props.item.debt_id }}
                </td>
                <td class="text-center" v-else-if="props.item.agent_id">
                  {{ $t("agents.agent") }} {{ $t("custom.number") }}
                  <router-link :to="{ path: `/agent_card/${props.item.agent_id}` }">{{ props.item.agent_id }}</router-link>
                </td>
                <td class="text-center" v-else-if="props.item.investor_id">
                  <router-link :to="{ path: `/investors/${props.item.investor_id}` }">
                    {{ $t("employers.partner") }} {{ $t("custom.number") }}{{ props.item.investor_id }}
                  </router-link>
                </td>
                <td class="text-center" v-else>-</td>
              </tr>
            </template>
          </v-data-table>
          
          <v-container v-if="!loadingPayments && categoryPayments.length === 0">
            <v-row justify="center" class="pa-10">
              <v-col cols="12" class="text-center">
                <v-icon size="64" color="grey lighten-1">mdi-cash-remove</v-icon>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        
        <v-divider></v-divider>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="categoryDialog = false">
            {{ $t('custom.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { GChart } from "vue-google-charts";
import VueHtml2pdf from "vue-html2pdf";
import { Capacitor } from "@capacitor/core";
import PullToRefresh from "pulltorefreshjs";
import CableSubscriber from "@/mixins/CableSubscriber";
export default {
  mixins: [CableSubscriber],
  data() {
    return {
      report: {},
      property: false,
      pie_chart_data: [],
      revenue_for_period_data: [],
      pie_chart_income_data: [],
      pie_chart_expences_data: [],
      showExcel: false,
      showRevenueGraf: false,
      showRevenueColumn: false,
      showRevenueTable: false,
      showClientsData: false,
      isMobile: false,
      isLoading: false,
      error: "",
      // WebSocket статус
      isGenerating: false,
      isRecalculating: false,
      connected: false,
      reportProgress: 0,
      generationError: null,
      // Данные о филиалах
      branches: [],
      current_branch_name: '',
      // Диалог с детальными платежами
      categoryDialog: false,
      categoryPayments: [],
      categoryTitle: '',
      categoryType: '',
      loadingPayments: false,
      paymentHeaders: [
        { text: this.$t("custom.number"), align: "center", value: "id" },
        { text: this.$t("custom.created_at"), value: "created_at", align: "center" },
        { text: this.$t("custom.group"), value: "group", align: "center" },
        { text: this.$t("custom.description"), value: "description", align: "center" },
        { text: this.$t("custom.amount"), value: "sum", align: "center" },
        { text: this.$t("custom.operation"), value: "operation", align: "center" },
        { text: this.$t("custom.type"), value: "cashless", align: "center" },
        { text: this.$t("contractors.contractor"), value: "contractor_id", align: "center" },
        { text: this.$t("custom.source"), sortable: false, align: "center" },
      ],
      paymentHeadersWithCurrency: [
        { text: this.$t("custom.number"), align: "center", value: "id" },
        { text: this.$t("custom.created_at"), value: "created_at", align: "center" },
        { text: this.$t("custom.group"), value: "group", align: "center" },
        { text: this.$t("companies.count"), value: "company_cashbox_id", align: "center" },
        { text: this.$t("custom.description"), value: "description", align: "center" },
        { text: this.$t("custom.amount"), value: "sum", align: "center" },
        { text: this.$t("custom.operation"), value: "operation", align: "center" },
        { text: this.$t("custom.type"), value: "cashless", align: "center" },
        { text: this.$t("contractors.contractor"), value: "contractor_id", align: "center" },
        { text: this.$t("custom.source"), sortable: false, align: "center" },
      ],
    };
  },
  created() {
    setMomentLocale(this.$i18n.locale);
    if (
      this.$store.getters.isLoggedIn &&
      (this.$store.getters.isSuperAdmin ||
        this.$store.getters.isAdmin ||
        this.$store.getters.isGuest)
    ) {
      this.isLoading = true;
      // Используем loadReport() для загрузки данных
      this.loadReport();
    } else {
      this.$router.push({ path: `/dashboard` }).catch((err) => { });
      this.$notify(this.$t("errors.only_admins"), "", "warning", 5000);
    }
  },
  mounted() {
    let self = this;
    const ptr = PullToRefresh.init({
      mainElement: "body",
      distIgnore: 100,
      instructionsPullToRefresh: this.$t("custom.pull_to_refresh"),
      instructionsReleaseToRefresh: this.$t("custom.release_to_refresh"),
      instructionsRefreshing: this.$t("custom.refreshing"),
    });
    if (
      this.$tours["registrationTour"] &&
      this.$store.getters.getTourNextStep
    ) {
      this.$tours["registrationTour"].nextStep();
    }
  },
  beforeDestroy() {
    // Отписываемся от WebSocket при уничтожении компонента
    this.unsubscribeFromReport()
  },
  computed: {
    company() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company) {
        return this.$store.getters.getCompany.company;
      }
      return null;
    },
    start_date_formatted() {
      return moment(this.report.start_date).format("DD.MM.YYYY");
    },
    end_date_formatted() {
      return moment(this.report.end_date).format("DD.MM.YYYY");
    },
    daysPeriod() {
      if (!this.report.start_date || !this.report.end_date) return 0;
      return moment(this.report.end_date).diff(moment(this.report.start_date), 'days') + 1;
    },
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
    currencies() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currencies
      ) {
        return this.$store.getters.getCompany.company.currencies;
      } else {
        return [];
      }
    },
    isIos() {
      return Capacitor.getPlatform().toLowerCase() == "ios" ? true : false;
    },
    // Опции графиков с поддержкой темной темы
    pieIncomeOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("custom.income"),
        pieHole: 0.4,
        sliceVisibilityThreshold: 0.00014,
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
      };
    },
    pieExpencesOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("custom.expences"),
        pieHole: 0.4,
        sliceVisibilityThreshold: 0.00014,
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
      };
    },
    pieIncomeOptionsPdf() {
      return {
        title: this.$t("custom.income"),
        pieHole: 0.4,
        sliceVisibilityThreshold: 0.00014,
        height: 480,
        titleTextStyle: { color: "#000000" },
        backgroundColor: "#FFFFFF",
        legend: {
          textStyle: { color: "#000000" },
        },
      };
    },
    pieExpencesOptionsPdf() {
      return {
        title: this.$t("custom.expences"),
        pieHole: 0.4,
        sliceVisibilityThreshold: 0.00014,
        width: 800,
        height: 480,
        titleTextStyle: { color: "#000000" },
        backgroundColor: "#FFFFFF",
        legend: {
          textStyle: { color: "#000000" },
        },
      };
    },
    barChartOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.common_profit"),
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
      };
    },
    barChartOptionsPdf() {
      return {
        title: this.$t("analitics.common_profit"),
        height: 600,
        titleTextStyle: { color: "#000000" },
        backgroundColor: "#FFFFFF",
        legend: {
          textStyle: { color: "#000000" },
        },
        hAxis: {
          textStyle: { color: "#000000" },
          titleTextStyle: { color: "#000000" },
        },
        vAxis: {
          textStyle: { color: "#000000" },
          titleTextStyle: { color: "#000000" },
        },
      };
    },
    // KPI метрики
    marginPercent() {
      if (!this.report.income || this.report.income === 0) return 0;
      return ((this.report.income - this.report.expense) / this.report.income * 100).toFixed(1);
    },
    averageIncomePerDay() {
      if (!this.report.start_date || !this.report.end_date) return 0;
      const days = moment(this.report.end_date).diff(moment(this.report.start_date), 'days') + 1;
      return (this.report.income / days).toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    averageExpensePerDay() {
      if (!this.report.start_date || !this.report.end_date) return 0;
      const days = moment(this.report.end_date).diff(moment(this.report.start_date), 'days') + 1;
      return (this.report.expense / days).toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    adsRoiPercent() {
      if (!this.report.ads_expense || this.report.ads_expense === 0) return 0;
      // ROI = (Прибыль / Расходы на рекламу) * 100
      const profit = this.report.income - this.report.expense;
      return ((profit / this.report.ads_expense) * 100).toFixed(1);
    },
    // Топ-5 источников доходов
    topIncomeData() {
      const incomes = [
        { name: this.$t("counts.rental_cost"), value: parseFloat(this.report.rent_income) },
        { name: this.$t("counts.delivery"), value: parseFloat(this.report.delivery_income) },
        { name: this.$t("counts.checkout"), value: parseFloat(this.report.checkout_income) },
        { name: this.$t("counts.gas_payments"), value: parseFloat(this.report.fuel_income) },
        { name: this.$t("counts.clean_payments"), value: parseFloat(this.report.clean_income) },
        { name: this.$t("counts.add_hours_payments"), value: parseFloat(this.report.add_time_income) },
        { name: this.$t("counts.repair_payments"), value: parseFloat(this.report.damages_income) },
        { name: this.$t("counts.fines_payments"), value: parseFloat(this.report.fines_income) },
        { name: this.$t("counts.other_payments"), value: parseFloat(this.report.other_income) },
        { name: this.$t("groups_counts.mileage"), value: parseFloat(this.report.mileage_income) },
        { name: this.$t("counts.insurance_payments"), value: parseFloat(this.report.insurance_income) },
        { name: this.$t("counts.drivers_payments"), value: parseFloat(this.report.drivers_income) },
        { name: this.$t("groups_counts.equipment"), value: parseFloat(this.report.equipment_income) },
        { name: this.$t("groups_counts.different_income"), value: parseFloat(this.report.different_income) },
      ];
      
      const top5 = incomes.sort((a, b) => b.value - a.value).slice(0, 5);
      return [
        [this.$t("custom.income"), this.$t("custom.sum"), { role: 'style' }, { role: 'annotation' }],
        ...top5.map(item => [item.name, item.value, '#4CAF50', item.value.toFixed(1)])
      ];
    },
    topIncomeOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.top_income_sources"),
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: { position: 'none' },
        chartArea: { width: '60%', height: '70%' },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        annotations: {
          textStyle: {
            color: isDark ? "#FFFFFF" : "#000000",
            fontSize: 12,
          },
          alwaysOutside: true,
        },
      };
    },
    // Топ-5 расходов
    topExpenseData() {
      const expenses = [
        { name: this.$t("counts.salary"), value: parseFloat(this.report.salary_expense) },
        { name: this.$t("counts.transport_expences"), value: parseFloat(this.report.transport_expense) },
        { name: this.$t("counts.common_expences"), value: parseFloat(this.report.common_expense) },
        { name: this.$t("counts.gas_fill"), value: parseFloat(this.report.fuel_expense) },
        { name: this.$t("custom.clean"), value: parseFloat(this.report.clean_expense) },
        { name: this.$t("counts.repair"), value: parseFloat(this.report.repair_expense) },
        { name: this.$t("custom.service"), value: parseFloat(this.report.service_expense) },
        { name: this.$t("custom.fines"), value: parseFloat(this.report.fines_expense) },
        { name: this.$t("counts.taxes"), value: parseFloat(this.report.taxes_expense) },
        { name: this.$t("counts.ads"), value: parseFloat(this.report.ads_expense) },
        { name: this.$t("custom.insurance"), value: parseFloat(this.report.insurance_expense) },
        { name: this.$t("counts.rent_office"), value: parseFloat(this.report.rent_property_expense) },
        { name: this.$t("counts.partners_payments"), value: parseFloat(this.report.partners_expense) },
        { name: this.$t("counts.parts"), value: parseFloat(this.report.parts_expense) },
        { name: this.$t("groups_counts.other_expence"), value: parseFloat(this.report.other_expence) },
      ];
      
      const top5 = expenses.sort((a, b) => b.value - a.value).slice(0, 5);
      return [
        [this.$t("analitics.expence"), this.$t("custom.sum"), { role: 'style' }, { role: 'annotation' }],
        ...top5.map(item => [item.name, item.value, '#F44336', item.value.toFixed(1)])
      ];
    },
    topExpenseOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.top_expense_sources"),
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: { position: 'none' },
        chartArea: { width: '60%', height: '70%' },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        annotations: {
          textStyle: {
            color: isDark ? "#FFFFFF" : "#000000",
            fontSize: 12,
          },
          alwaysOutside: true,
        },
      };
    },
    // Общая сумма платежей в диалоге
    // Используем ту же логику, что и в CalculateCompanyReportJob
    categoryTotalSum() {
      if (this.categoryPayments && this.categoryPayments.length > 0) {
        // Сначала суммируем платежи в базовой валюте (rated_sum == null)
        const baseSum = this.categoryPayments
          .filter(p => p.rated_sum == null)
          .reduce((sum, payment) => sum + parseFloat(payment.sum || 0), 0);
        
        // Потом добавляем платежи в других валютах (rated_sum != null)
        const ratedSum = this.categoryPayments
          .filter(p => p.rated_sum != null)
          .reduce((sum, payment) => sum + parseFloat(payment.rated_sum || 0), 0);
        
        return baseSum + ratedSum;
      }
      return 0;
    },
    
    // Операционная эффективность
    operationalEfficiencyData() {
      const expenses = [
        { name: this.$t("counts.salary"), value: parseFloat(this.report.salary_expense) },
        { name: this.$t("counts.transport_expences"), value: parseFloat(this.report.transport_expense) },
        { name: this.$t("counts.common_expences"), value: parseFloat(this.report.common_expense) },
        { name: this.$t("counts.gas_fill"), value: parseFloat(this.report.fuel_expense) },
        { name: this.$t("custom.clean"), value: parseFloat(this.report.clean_expense) },
        { name: this.$t("counts.repair"), value: parseFloat(this.report.repair_expense) },
        { name: this.$t("custom.service"), value: parseFloat(this.report.service_expense) },
        { name: this.$t("custom.fines"), value: parseFloat(this.report.fines_expense) },
        { name: this.$t("counts.taxes"), value: parseFloat(this.report.taxes_expense) },
        { name: this.$t("counts.ads"), value: parseFloat(this.report.ads_expense) },
        { name: this.$t("custom.insurance"), value: parseFloat(this.report.insurance_expense) },
        { name: this.$t("counts.rent_office"), value: parseFloat(this.report.rent_property_expense) },
        { name: this.$t("counts.partners_payments"), value: parseFloat(this.report.partners_expense) },
        { name: this.$t("counts.parts"), value: parseFloat(this.report.parts_expense) },
        { name: this.$t("groups_counts.other_expence"), value: parseFloat(this.report.other_expence) },
      ];
      
      // Цвета для топ-10 расходов
      const colors = ['#FF5722', '#FF9800', '#9C27B0', '#3F51B5', '#009688', '#00BCD4', '#4CAF50', '#8BC34A', '#FFC107', '#E91E63'];
      
      // Топ-10 расходов с самым большим процентом от доходов
      const top10 = expenses
        .filter(item => item.value > 0)
        .sort((a, b) => b.value - a.value)
        .slice(0, 10);
        
      return [
        [this.$t("analitics.expence"), this.$t("custom.sum"), { role: 'style' }, { role: 'annotation' }],
        ...top10.map((item, index) => [
          item.name, 
          item.value, 
          colors[index], 
          (item.value / this.report.income * 100).toFixed(1) + '%'
        ])
      ];
    },
    operationalEfficiencyOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.operational_efficiency") + ' (' + this.$t("analitics.percent_of_income") + ')',
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: { position: 'none' },
        chartArea: { width: '70%', height: '70%' },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        annotations: {
          textStyle: {
            color: isDark ? "#FFFFFF" : "#000000",
            fontSize: 12,
          },
          alwaysOutside: true,
        },
      };
    },
    // PDF опции для новых графиков
    topIncomeOptionsPdf() {
      return {
        title: this.$t("analitics.top_income_sources"),
        titleTextStyle: { color: "#000000" },
        backgroundColor: "#FFFFFF",
        legend: { position: 'none' },
        chartArea: { width: '60%', height: '70%' },
        height: 600,
        hAxis: {
          textStyle: { color: "#000000" },
          titleTextStyle: { color: "#000000" },
        },
        vAxis: {
          textStyle: { color: "#000000" },
          titleTextStyle: { color: "#000000" },
        },
        annotations: {
          textStyle: {
            color: "#000000",
            fontSize: 12,
          },
          alwaysOutside: true,
        },
      };
    },
    topExpenseOptionsPdf() {
      return {
        title: this.$t("analitics.top_expense_sources"),
        titleTextStyle: { color: "#000000" },
        backgroundColor: "#FFFFFF",
        legend: { position: 'none' },
        chartArea: { width: '60%', height: '70%' },
        height: 600,
        hAxis: {
          textStyle: { color: "#000000" },
          titleTextStyle: { color: "#000000" },
        },
        vAxis: {
          textStyle: { color: "#000000" },
          titleTextStyle: { color: "#000000" },
        },
        annotations: {
          textStyle: {
            color: "#000000",
            fontSize: 12,
          },
          alwaysOutside: true,
        },
      };
    },
    operationalEfficiencyOptionsPdf() {
      return {
        title: this.$t("analitics.operational_efficiency") + ' (' + this.$t("analitics.percent_of_income") + ')',
        titleTextStyle: { color: "#000000" },
        backgroundColor: "#FFFFFF",
        legend: { position: 'none' },
        chartArea: { width: '70%', height: '70%' },
        height: 600,
        hAxis: {
          textStyle: { color: "#000000" },
          titleTextStyle: { color: "#000000" },
        },
        vAxis: {
          textStyle: { color: "#000000" },
          titleTextStyle: { color: "#000000" },
        },
        annotations: {
          textStyle: {
            color: "#000000",
            fontSize: 12,
          },
          alwaysOutside: true,
        },
      };
    },
  },
  methods: {
    // Маппинг категорий отчета на категории платежей
    getCategoryMapping(categoryField) {
      const mapping = {
        'rent_income': 'Оплата аренды',
        'delivery_income': 'Доплата за доставку',
        'checkout_income': 'Доплата за приём',
        'fuel_income': 'Доплата за топливо',
        'clean_income': 'Доплата за мойку',
        'add_time_income': 'Доплата за дополнительное время',
        'damages_income': 'Доплата за повреждения',
        'fines_income': 'Доплата за штрафы',
        'other_income': 'Доплата за другое',
        'mileage_income': 'Доплата за превышение пробега',
        'insurance_income': 'Доплата за страховку',
        'drivers_income': 'Доплата за доп водителей',
        'equipment_income': 'Доплата за оборудование',
        'different_income': 'Прочие доходы',
        'sale_property_income': 'Продажа имущества',
        
        'salary_expense': 'Зарплата',
        'transport_expense': 'Транспортные расходы',
        'common_expense': 'Накладные расходы',
        'fuel_expense': 'Топливо',
        'clean_expense': 'Мойка автомобилей',
        'repair_expense': 'Ремонт',
        'service_expense': 'Обслуживание',
        'fines_expense': 'Штрафы',
        'taxes_expense': 'Налоги',
        'ads_expense': 'Реклама',
        'insurance_expense': 'Страховка',
        'rent_property_expense': 'Аренда имущества',
        'partners_expense': 'Выплаты партнёрам',
        'other_expence': 'Прочие расходы',
        'parts_expense': 'Запчасти',
        'buy_property_expense': 'Покупка имущества'
      };
      
      return mapping[categoryField];
    },
    
    showCategoryDetails(categoryField, categoryTitle) {
      const categoryValue = this.getCategoryMapping(categoryField);
      
      if (!categoryValue) {
        this.$notify(this.$t('errors.error'), 'Category not found', 'error', 3000);
        return;
      }
      
      this.categoryTitle = categoryTitle;
      this.categoryType = categoryField;
      this.categoryDialog = true;
      this.loadingPayments = true;
      this.categoryPayments = [];
      
      // Запрос к серверу
      this.axios
        .get(`/api/v1/company_reports/${this.report.id}/category_payments`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
          params: {
            category: categoryValue,
            start_date: this.report.start_date,
            end_date: this.report.end_date
          }
        })
        .then((response) => {
          this.categoryPayments = response.data.payments || [];
          this.loadingPayments = false;
        })
        .catch((error) => {
          console.log(error);
          this.loadingPayments = false;
          this.$notify(
            this.$t('errors.error'),
            error.response?.data?.error || this.$t('errors.error_loading_payments'),
            'error',
            5000
          );
        });
    },
    
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY HH:mm');
    },
    
    returnDate(item) {
      return moment.parseZone(item).format("lll");
    },
    
    translateCategory(category) {
      let group_text = "";
      switch (category) {
        case "Оплата аренды":
          group_text = this.$t("groups_counts.rent");
          break;
        case "Доплата за доставку":
          group_text = this.$t("groups_counts.delivery");
          break;
        case "Доплата за приём":
          group_text = this.$t("groups_counts.checkout");
          break;
        case "Доплата за топливо":
          group_text = this.$t("groups_counts.fuel");
          break;
        case "Доплата за мойку":
          group_text = this.$t("groups_counts.clean");
          break;
        case "Доплата за оборудование":
          group_text = this.$t("groups_counts.equipment");
          break;
        case "Доплата за дополнительное время":
          group_text = this.$t("groups_counts.add_time");
          break;
        case "Доплата за повреждения":
          group_text = this.$t("groups_counts.damages");
          break;
        case "Доплата за штрафы":
          group_text = this.$t("groups_counts.fines");
          break;
        case "Доплата за другое":
          group_text = this.$t("groups_counts.other");
          break;
        case "Доплата за превышение пробега":
          group_text = this.$t("groups_counts.mileage");
          break;
        case "Доплата за страховку":
          group_text = this.$t("groups_counts.insurance");
          break;
        case "Доплата за доп водителей":
          group_text = this.$t("groups_counts.add_drivers");
          break;
        case "Ремонт":
          group_text = this.$t("groups_counts.repair");
          break;
        case "Обслуживание":
          group_text = this.$t("groups_counts.service");
          break;
        case "Запчасти":
          group_text = this.$t("groups_counts.parts");
          break;
        case "Страховка":
          group_text = this.$t("groups_counts.insurance_main");
          break;
        case "Накладные расходы":
          group_text = this.$t("groups_counts.common_expences");
          break;
        case "Транспортные расходы":
          group_text = this.$t("groups_counts.transport_expences");
          break;
        case "Налоги":
          group_text = this.$t("groups_counts.tax");
          break;
        case "Штрафы":
          group_text = this.$t("groups_counts.fines_main");
          break;
        case "Аренда имущества":
          group_text = this.$t("groups_counts.rent_property");
          break;
        case "Мойка автомобилей":
          group_text = this.$t("groups_counts.clean_main");
          break;
        case "Топливо":
          group_text = this.$t("groups_counts.fuel_main");
          break;
        case "Реклама":
          group_text = this.$t("groups_counts.ads");
          break;
        case "Зарплата":
          group_text = this.$t("groups_counts.salary");
          break;
        case "Залог":
          group_text = this.$t("groups_counts.deposit");
          break;
        case "Внутренние переводы":
          group_text = this.$t("groups_counts.internal");
          break;
        case "Выплаты партнёрам":
          group_text = this.$t("groups_counts.partners_payments");
          break;
        case "Продажа имущества":
          group_text = this.$t("groups_counts.sell_property");
          break;
        case "Покупка имущества":
          group_text = this.$t("groups_counts.buy_property");
          break;
        case "Прочие расходы":
          group_text = this.$t("groups_counts.other_expences");
          break;
        case "Прочие доходы":
          group_text = this.$t("groups_counts.other_incomes");
          break;
        case "Сервисные сборы":
          group_text = this.$t("groups_counts.service_fees");
          break;
        case "Пополнение баланса клиента":
          group_text = this.$t("groups_counts.top_up_client_balance");
          break;
        case "Выплаты агентам":
          group_text = this.$t("groups_counts.agent_payments");
          break;
      }
      return group_text;
    },
    
    findCashboxName(company_cashbox_id, currency_id) {
      if (company_cashbox_id != null) {
        const cashbox = this.$store.getters.getCompany?.company?.company_cashboxes?.find(
          (cashbox) => cashbox.id == company_cashbox_id
        );
        if (cashbox) {
          return cashbox.name;
        } else {
          const currency = this.currencies.find((currency) => currency.id == currency_id);
          if (currency) {
            return currency.symbol;
          }
        }
      }
      return "-";
    },
    
    getBranchName() {
      if (this.report.all_branches) {
        return this.$t('custom.all_branches');
      }
      
      if (this.report.company_id) {
        const branch = this.branches.find(b => b.id === this.report.company_id);
        return branch ? branch.name : this.current_branch_name;
      }
      
      return this.current_branch_name;
    },
    loadReport() {
      this.axios
        .get(`/api/v1/company_reports/${this.$route.params.query}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.report = response.data;
          this.branches = response.data.branches || [];
          this.current_branch_name = response.data.current_branch_name || '';
          
          // Если отчет в статусе initial или pending, подписываемся на обновления
          if (this.report.state === 'initial' || this.report.state === 'pending') {
            this.isGenerating = true
            this.subscribeToReportUpdates()
          }
          
          this.revenue_for_period_data = [
            [
              this.$t("custom.income"),
              this.$t("custom.income"),
              this.$t("custom.expences"),
              this.$t("analitics.profit"),
            ],
            [
              "",
              parseFloat(this.report.income) || 0,
              parseFloat(this.report.expense) || 0,
              (parseFloat(this.report.income) || 0) - (parseFloat(this.report.expense) || 0),
            ],
          ];
          this.pie_chart_income_data = [
            [this.$t("custom.income"), this.$t("custom.sum")],
            [
              this.$t("counts_groups.rental_cost"),
              parseFloat(this.report.rent_income),
            ],
            [
              this.$t("counts_groups.delivery_payments"),
              parseFloat(this.report.delivery_income),
            ],
            [
              this.$t("counts_groups.checkout_payments"),
              parseFloat(this.report.checkout_income),
            ],
            [
              this.$t("counts_groups.gas_payments"),
              parseFloat(this.report.fuel_income),
            ],
            [
              this.$t("counts_groups.insurance_payments"),
              parseFloat(this.report.insurance_income),
            ],
            [
              this.$t("counts_groups.drivers_payments"),
              parseFloat(this.report.drivers_income),
            ],
            [
              this.$t("groups_counts.equipment"),
              parseFloat(this.report.equipment_income),
            ],
            [
              this.$t("counts_groups.clean_payments"),
              parseFloat(this.report.clean_income),
            ],
            [
              this.$t("counts_groups.add_hours_payments"),
              parseFloat(this.report.add_time_income),
            ],
            [
              this.$t("counts_groups.repair_payments"),
              parseFloat(this.report.damages_income),
            ],
            [
              this.$t("counts_groups.fines_payments"),
              parseFloat(this.report.fines_income),
            ],
            [
              this.$t("counts_groups.add_mileage_payments"),
              parseFloat(this.report.mileage_income),
            ],
            [
              this.$t("custom.other"),
              parseFloat(this.report.other_income),
            ],
            [
              this.$t("custom.different"),
              parseFloat(this.report.different_income),
            ],
          ];
          if (this.report.with_property == true) {
            this.pie_chart_income_data.push([
              this.$t("groups_counts.sell_property"),
              parseFloat(this.report.sale_property_income),
            ]);
          }
          this.pie_chart_expences_data = [
            [this.$t("custom.expences"), this.$t("custom.sum")],
            [
              this.$t("groups_counts.repair"),
              parseFloat(this.report.repair_expense),
            ],
            [
              this.$t("groups_counts.service"),
              parseFloat(this.report.service_expense),
            ],
            [
              this.$t("groups_counts.parts"),
              parseFloat(this.report.parts_expense),
            ],
            [
              this.$t("groups_counts.insurance"),
              parseFloat(this.report.insurance_expense),
            ],
            [
              this.$t("groups_counts.common"),
              parseFloat(this.report.common_expense),
            ],
            [
              this.$t("groups_counts.transport"),
              parseFloat(this.report.transport_expense),
            ],
            [
              this.$t("groups_counts.taxes"),
              parseFloat(this.report.taxes_expense),
            ],
            [
              this.$t("groups_counts.fines"),
              parseFloat(this.report.fines_expense),
            ],
            [
              this.$t("groups_counts.ads"),
              parseFloat(this.report.ads_expense),
            ],
            [
              this.$t("groups_counts.salary"),
              parseFloat(this.report.salary_expense),
            ],
            [
              this.$t("groups_counts.gas"),
              parseFloat(this.report.fuel_expense),
            ],
            [
              this.$t("groups_counts.clean"),
              parseFloat(this.report.clean_expense),
            ],
            [
              this.$t("groups_counts.property_rent"),
              parseFloat(this.report.rent_property_expense),
            ],
            [
              this.$t("groups_counts.partners"),
              parseFloat(this.report.partners_expense),
            ],
            [
              this.$t("custom.other"),
              parseFloat(this.report.other_expence),
            ],
          ];
          if (this.report.with_property == true) {
            this.pie_chart_expences_data.push([
              this.$t("groups_counts.buy_property"),
              parseFloat(this.report.buy_property_expense),
            ]);
          }
          this.pie_chart_data = [
            [this.$t("custom.income"), this.$t("custom.sum")],
            [this.$t("custom.income"), parseFloat(this.report.income)],
            [this.$t("custom.expences"), parseFloat(this.report.expense)],
          ];
          this.showExcel = true;
          this.showRevenueGraf = true;
          this.showRevenueColumn = true;
          this.showRevenueTable = true;
          this.showClientsData = true;
          this.isLoading = false;
          this.error = "";
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
          this.isLoading = false;
        });
    },
    
    // FT-066: ReportsChannel handlers (moved from the old channels option; this-rebinding via
    // arrows in subscribeToReportUpdates). Bodies are 1:1 with the former declarative channel.
    onReportConnected() {
      this.connected = true
    },
    onReportDisconnected() {
      this.connected = false
    },
    onReportReceived(data) {
      if (data.report_id === this.report.id) {
        this.reportProgress = data.progress

        if (data.status === 'completed') {
          this.isGenerating = false
          this.loadReport()  // Перезагружаем отчет

          this.$notify(
            this.$t('analitics.report_ready'),
            this.$t('analitics.report_generated_successfully'),
            'success',
            5000
          )
        }

        if (data.status === 'failed') {
          this.isGenerating = false
          this.generationError = data.error || this.$t('analitics.report_generation_failed')

          this.$notify(this.$t('errors.error'), this.generationError, 'error', 5000)
        }
      }
    },

    subscribeToReportUpdates() {
      if (this.report && this.report.id) {
        // FT-066 switch pattern: drop any prior sub before re-subscribing (re-subscribe on
        // recalc / report change). Mixin auto-unsubscribes the held ref in beforeDestroy too.
        this.$cableUnsubscribe(this.reportSub)
        this.reportSub = this.$cableSubscribe(
          {
            channel: 'ReportsChannel',
            report_type: 'company',
            report_id: this.report.id
          },
          {
            connected: () => this.onReportConnected(),
            disconnected: () => this.onReportDisconnected(),
            received: (data) => this.onReportReceived(data)
          }
        )
      }
    },

    unsubscribeFromReport() {
      this.$cableUnsubscribe(this.reportSub)
      this.reportSub = null
    },
    
    recalculateReport() {
      if (!this.report || !this.report.id || this.isRecalculating) {
        return
      }

      this.isRecalculating = true
      this.generationError = null
      this.isGenerating = true
      this.reportProgress = 0

      this.unsubscribeFromReport()

      this.axios
        .post(`/api/v1/company_reports/${this.report.id}/recalculate`, {}, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then(() => {
          if (this.report) {
            this.report.state = 'pending'
          }
          this.subscribeToReportUpdates()
          this.$notify(
            this.$t('analitics.report_recalculation_started'),
            '',
            'success',
            3000
          )
        })
        .catch((error) => {
          this.isGenerating = false
          const message =
            (error.response && error.response?.data && error.response?.data.error) ||
            this.$t('analitics.report_recalculation_failed')
          let localizedMessage = message
          if (message === 'Report is already being processed') {
            localizedMessage = this.$t('analitics.report_already_processing')
          } else if (message === 'Recalculation is not available for demo reports') {
            localizedMessage = this.$t('analitics.report_recalculation_failed')
          }
          this.generationError = localizedMessage
          this.$notify(this.$t('errors.error'), localizedMessage, 'error', 5000)
        })
        .finally(() => {
          this.isRecalculating = false
        })
    },

    retryGeneration() {
      // Сбрасываем ошибку и перезагружаем отчет
      this.generationError = null
      this.isGenerating = true
      this.reportProgress = 0
      this.loadReport()
    },
    
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    with_property_warn() {
      this.$notify(this.$t("errors.with_property_warn"), "", "warning");
    },
    findCurrencySymbol(id) {
      if (id != null) {
        if (this.currencies.find((currency) => currency.id == id)) {
          return this.currencies.find((currency) => currency.id == id).symbol;
        }
      }
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
  },
  components: {
    VueHtml2pdf,
    GChart,
  },
};
</script>
